var map = {
	"./austria.png": "f3ab",
	"./belgium.png": "cdc5",
	"./czech_republic.png": "9e9b",
	"./denmark.png": "18d0",
	"./estonia.png": "4769",
	"./finland.png": "06c2",
	"./france.png": "4d54",
	"./germany.png": "eef6",
	"./great_britain.png": "e801",
	"./greece.png": "4eda",
	"./iceland.png": "e253",
	"./italy.png": "8d41",
	"./latvia.png": "7c1d",
	"./lithuania.png": "96bf",
	"./luxembourg.png": "f614",
	"./netherlands.png": "4c2d",
	"./norway.png": "e012",
	"./poland.png": "23a8",
	"./portugal.png": "e3cf",
	"./russia.png": "86e2",
	"./slovakia.png": "9f34",
	"./spain.png": "f3ab4",
	"./sweden.png": "38bb",
	"./switzerland.png": "8d22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";